import styled from 'styled-components'

export const StyledButtonsContainer = styled.ul`
    display: flex;
    align-items: flex-end;
    gap: 5px;
    list-style: none;

    .ant-btn {
        display: flex;
        align-items: flex-end;
        flex-direction: column;
        justify-content: end;
        padding: 0;
    }

    li {
        &:nth-child(1) button.ant-btn span {
            font-size: 1.5rem;
        }

        &:nth-child(2) button.ant-btn span {
            font-size: 2rem;
        }

        &:nth-child(3) button.ant-btn span {
            font-size: 2.5rem;
        }
    }
`
